<div class="layout-dashboard"></div>
<div class="grid">
    <p-toast></p-toast>
    <div class="col-12 xl:col-12">
        <div class="card">
            <div
                class="flex w-full justify-content-start align-items-start flex-column"
            >
                <h4 class="mb-4">{{"SEARCH_CUSTOMER" | translate}}</h4>
                <p-inputGroup class="w-25rem" [formGroup]="searchForm">
                    <input
                        type="text"
                        class="w-full"
                        pInputText
                        (keydown.enter)="logSearchTerm()"
                        formControlName="searchTermInput"
                        [placeholder]="'ENTER_CUSTOMER_SEARCH_TERM' | translate"
                    />
                </p-inputGroup>
            </div>
            <div class="spacer"></div>
            <p-table
                [paginator]="true"
                [rows]="8"
                [value]="customers"
                [rowsPerPageOptions]="[10, 15, 20]"
                (onPage)="pageChange($event)"
                responsiveLayout="scroll"
            >
                <ng-template pTemplate="header">
                    <tr>
                        <th>{{'CUSTOMER_NAME' | translate}}</th>
                        <th>{{'CUSTOMER_TYPE' | translate}}</th>
                        <th>{{'CONTACT_FULL_NAME' | translate}}</th>
                        <th>{{'MOBILE_NUMBER' | translate}}</th>
                        <th>{{'EMAIL' | translate}}</th>
                        <th>{{'ACTIONS' | translate}}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-customer>
                    <tr>
                        <td>
                            <span class="p-column-title">Full Name</span>
                            {{ customer.customerName }}
                        </td>
                        <td>
                            <span class="p-column-title">Customer Type</span>
                            {{ customer.customerType | translate}}
                        </td>
                        <td>
                            <span class="p-column-title"
                                >Contact Full Name</span
                            >
                            {{ customer.contactInfo.firstName }}
                            {{ customer.contactInfo.surname }}
                        </td>
                        <td>
                            <span class="p-column-title">Mobile Number</span>
                            {{ customer.contactInfo.contactMobileNumber }}
                        </td>
                        <td>
                            <span class="p-column-title">Email</span>
                            {{ customer.contactInfo.contactEmail }}
                        </td>
                        <td>
                            <p-button
                                class="table-button cursor-pointer"
                                [pTooltip]="'VIEW_CUSTOMER_DETAILS' | translate"
                                icon="pi pi-info-circle"
                                [rounded]="true"
                                (onClick)="viewCustomerClicked(customer)"
                                [text]="true"
                                severity="info"
                            />
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
